const FormRow = ({ children, onChange }) => {
  if (!children) return null;

  if (Array.isArray(children)) {
    const cnt = children.length;
    const flex = cnt > 1 ? 100 / cnt - 5 : 100;

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "15px",
        }}
      >
        {children.map((field, index) => {
          if (!field || !field.element) return null;

          return (
            <div
              key={index}
              style={{ flexBasis: field.flex ? field.flex + "%" : flex + "%" }}
            >
              <field.element onChange={onChange}>{field}</field.element>
            </div>
          );
        })}
      </div>
    );
  }

  if (!children.element) return null;

  return (
    <div style={{ marginBottom: "15px" }}>
      <children.element onChange={onChange}>{children}</children.element>
    </div>
  );
};

export default FormRow;
